export enum ReduxSettingsState {
  RESET_STATE = 'SETTINGS_RESET_STATE',
  REQUEST_LOADING = 'SETTINGS_REQUEST_LOADING',
  REQUEST_SUCCESS = 'SETTINGS_REQUEST_SUCCESS',
  REQUEST_FAILED = 'SETTINGS_REQUEST_FAILED',
  UPDATE_CURRENCY = 'SETTINGS_UPDATE_CURRENCY'
}